/**
 * @deprecated Do not use it in the new code base. Use `generateUUID` from `utils`
 * @todo Remove it once notistack will be removed from packages
 */
export function generateUniqueId() {
  return new Date().getTime() + Math.random();
}
